module.exports = "/images/ny-life2-13.jpg";